module.exports = __webpack_public_path__ + "archivist_badge_05.jpg?6ce9f372247be113aeb06239afb6d17f";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge/archivist_badge_05.jpg
// module id = 380
// module chunks = 0